import { useContext, useEffect, useState } from 'react'

import { useDispatch, useSelector } from 'react-redux'
import { IRedux } from 'store/ducks'
import Creators from 'store/ducks/authenticate'
import { ListItem, Tooltip } from '@mui/material'
import { ReactComponent as DrawerCloseIcon } from 'assets/icons/drawer/drawer_close_icon.svg'
import { ReactComponent as DrawerOpenIcon } from 'assets/icons/drawer/drawer_open_icon.svg'
import { ReactComponent as CsnLogo } from 'assets/images/logo_csn.svg'
import Logotipo from 'assets/images/logotipo_csn.png'
import { Col, Image, Row } from 'components'
import { DrawerContext } from 'context/DrawerContext'
import { useAuth } from 'hooks'
import { UsuarioToken } from 'hooks/useAuth'
import { useHistory, useLocation } from 'react-router-dom'
import { SPACING } from 'utils'
import jwt from 'jsonwebtoken'

import IconContainer from './components/IconContainer/IconContainer'
import {
  DrawerContainer,
  DrawerContent,
  Drawermain,
  ListItemIconStyled,
  ListItemTextStyled,
  ListStyled,
  Overflow
} from './Drawer.styles'
import { masterList, IRoutes, ISubRoutes } from './routes_list'
import { number } from 'yup'
const DrawerMenu = () => {
  const dispatch = useDispatch()
  const [isHovered, setIsHovered] = useState(false);
  const { token } = useAuth()
  const { handleDrawer, isOpen } = useContext(DrawerContext)
  const [isNewPerfil, setIsNewPerfil] = useState(true);
  const { pathname } = useLocation()
  const { push } = useHistory()
  const [subRoutesState, setSubRoutesState] = useState<ISubRoutes[] | null>(null)
  const [routes, setRoutes] = useState(masterList)
  const [isSubHovered, setIsSubHovered] = useState(false);
  // const user = useSelector((state: IRedux) => state.auth.user)
  // const setUser = (newUser: UsuarioToken) => dispatch(Creators.user(newUser))
  const [user, setUser] = useState<UsuarioToken | null>(null)
  const tkn = localStorage.getItem('csn-tk')

  const handleSelectSubRoutes = (route: IRoutes) => {
    // SE DRAWER TIVER MINIMIZADO, MAXIMIZA
    if (!isOpen) {
      handleDrawer(true)
    }
    // SE ROTA NAO TEM SUB ROTAS VAI PARA ROTA DISPONIVEL
    if (route.subRoutes.length === 0) {
      push(route.path)
      handleDrawer(false)
    } else {
      setSubRoutesState(route.subRoutes)

      if (user.PerfilUsuarioId == 6 && route.title === 'Relatórios') {
        route.subRoutes[5].disable = true;
      }

    }
  }

  const handleSelectPath = (path: string, disabled) => {
    if (path === 'voltar') {
      setSubRoutesState(null)
      return
    }

    if (!disabled) {
      push(path)
      setSubRoutesState(null)
      handleDrawer(false)
    }

    // Limpar formularios persistentes.
    Object.keys(localStorage).forEach(key => {
      if (/FORM_/g.test(key)) {
        localStorage.removeItem(key)
      }
    })
  }

  const handleDescript = (data: any) =>
    !data ? null : JSON.parse(window.atob(data))

  useEffect(() => {
    const tokenDescrited = jwt.decode(tkn)
    const newUser = handleDescript(tokenDescrited?.Usuario)
    if (newUser != null)
      newUser.PerfilUsuarioId = parseInt(newUser.PerfilUsuarioId)
    setUser(newUser)

    const findRoute = () => {
      const copyRoutes = routes.slice()
      copyRoutes.forEach((route) => {
        route.selected = false
        if (route.path === pathname && route.subRoutes.length === 0) {
          route.selected = true
        } else {
          route.subRoutes?.forEach((subRoute) => {
            if (subRoute.path === pathname && route.subRoutes.length > 0) {
              subRoute.selected = true
              route.selected = true
            } else {
              subRoute.selected = false
            }
          })
        }
      })
      setRoutes(copyRoutes)
    }
    findRoute()
  }, [pathname])

  useEffect(() => {
    const tokenDescrited = jwt.decode(tkn)
    const newUser = handleDescript(tokenDescrited?.Usuario)
    if (newUser != null)
      newUser.PerfilUsuarioId = parseInt(newUser.PerfilUsuarioId)
    setUser(newUser)
    const rollBackMenu = () => {
      if (!isOpen) {
        setSubRoutesState(null)
      }
    }
    rollBackMenu()
  }, [isOpen])

  useEffect(() => {
    const tokenDescrited = jwt.decode(tkn)
    const newUser = handleDescript(tokenDescrited?.Usuario)
    if (newUser != null)
      newUser.PerfilUsuarioId = parseInt(newUser.PerfilUsuarioId)
    setUser(newUser)
    setIsNewPerfil(false)
  }, [isNewPerfil])

  const hideThisPage =
    pathname === '/fornecedor/access' ||
    pathname === '/ngt/access' ||
    pathname === '*' ||
    pathname === '/' ||
    pathname.includes('/validacao') ||
    pathname.includes('/recuperar')


  return (
    <DrawerContainer
      variant="permanent"
      open={isOpen}
      hide={hideThisPage}
      onBlur={() => handleDrawer(false)}
    >
      <DrawerContent isOpen={isOpen}>
        <Col
          gap=".7rem"
          alignItems="center"
          justifyContent="center"
          marginTop="43px"
        >
          <CsnLogo />
          {isOpen && <Image src={Logotipo} width="4.8rem" />}
        </Col>

        <Row
          alignItems="center"
          justifyContent="flex-end"
          marginTop={SPACING.spacing50}
        >
          <Overflow
            onClick={() => handleDrawer(isOpen ? false : true)}
            isOpen={isOpen}
          >
            {isOpen ? (
              <DrawerCloseIcon className="icon-drawer" />
            ) : (
              <DrawerOpenIcon className="icon-drawer" />
            )}
          </Overflow>
        </Row>

        <Drawermain>
          <ListStyled>
            {subRoutesState === null &&
              routes
                ?.filter(
                  (el) =>
                    el?.permition?.length == 0 ||
                    el?.permition?.includes(user?.PerfilUsuarioId)
                )
                ?.map((route, index) => {

                  return (
                    <ListItem
                      key={`${route.title}${index}`}
                      onClick={() => handleSelectSubRoutes(route)}
                      alignItems="center"

                    >
                      <Tooltip
                        disableHoverListener={isOpen}
                        title={route.title}
                      >
                        <ListItemIconStyled>
                          <IconContainer
                            selected={route.selected}
                            isOpen={isOpen}
                          >
                            {route.icon}
                          </IconContainer>
                        </ListItemIconStyled>
                      </Tooltip>
                      {isOpen && (
                        <ListItemTextStyled>{route.title}</ListItemTextStyled>
                      )}
                    </ListItem>
                  )
                })}

            <div
              onMouseEnter={() => setIsHovered(true)}
              onMouseLeave={() => setIsHovered(false)}
            >
              {subRoutesState !== null &&
                subRoutesState
                  ?.filter(
                    (el) =>
                      el?.permition?.length === 0 ||
                      el?.permition?.includes(user?.PerfilUsuarioId)
                  )
                  ?.map((subRoutes, index) => {
                    const isRelatorioContraparte = subRoutes.title === "Relatório Contraparte";
                    const isMovimentacaoPagamento = subRoutes.title === "Movimentação e Pagamento";
                    const isIndented = user.PerfilUsuarioId === 6 &&
                      (subRoutes.title === "Movimentação e Pagamento" || subRoutes.title === "Pendências Abertas");



                    return (
                      <ListItem
                        key={`${subRoutes.title}${index}`}
                        onClick={() => {
                          if (
                            (subRoutes.permition &&
                              subRoutes.permition.length > 0 &&
                              subRoutes.permition.includes(user?.PerfilUsuarioId)) ||
                            subRoutes.path === 'voltar'
                          ) {
                            handleSelectPath(subRoutes.path, subRoutes.disable);
                          }
                        }}
                        className={`subMenus ${isIndented ? 'indented-route' : ''}`}
                        disabled={
                          subRoutes.permition &&
                            subRoutes.permition.length > 0 &&
                            !subRoutes.permition.includes(user.PerfilUsuarioId)
                            ? true
                            : false
                        }
                      >
                        <ListItemTextStyled
                          selected={subRoutes.selected}
                          style={isIndented ? { marginLeft: '25px' } : {}}
                        >
                          {subRoutes.title}
                        </ListItemTextStyled>
                      </ListItem>
                    );
                  })}
            </div>
          </ListStyled>
        </Drawermain>
      </DrawerContent>
    </DrawerContainer>
  )
}

export default DrawerMenu